<template>
  <div class="contact-details">
    <div class="contact-details__detail">
      <div class="contact-details__detail__title">
        {{ $t('Office/Showroom') }}
      </div>
      <div class="contact-details__detail__content">
        <div class="contact-details__detail__content__line">
          {{ $t('Via Castellantico, 17') }}
        </div>
        <div class="contact-details__detail__content__line">
          {{ $t('30035 Mirano') }}
        </div>
        <div class="contact-details__detail__content__line">
          {{ $t('VENICE') }}
        </div>
        <div class="contact-details__detail__content__line">
          {{ $t('P.I: 04513400277') }}
        </div>
      </div>
    </div>
    <div class="contact-details__detail">
      <div class="contact-details__detail__title">
        {{ $t('Contact') }}
      </div>
      <div class="contact-details__detail__content">
        <div class="contact-details__detail__content__line">
          {{ $t('Tel.+39 041 4762538') }}
        </div>
        <div class="contact-details__detail__content__line">
          {{ $t('Tel.:+39 327 8460693') }}
        </div>
        <div class="contact-details__detail__content__line">
          {{ $t('info@sognidicristallo.it') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ContactDetails',
});
</script>

<style lang="scss" scoped>
.contact-details {
  &__detail {
    &__title {
      @include mobile-h6;
    }
    &__content {
      margin-top: 0.625rem;
      @include paragraph-m;
      &__line {
        margin-top: 0.3125rem;
      }
    }
    &:not(:first-child) {
      margin-top: 1.25rem;
    }
  }
  @include from-desktop-min {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-around;
    margin: 0;
    &__detail {
      &__title {
        @include desktop-h6;
      }
    }
  }
}
</style>
